angular.module('property-deal')
    .controller('PropertyDealStatusController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyDeal, Project, PropertyService, PropertyDealService, LeadService) {
        this.PropertyService = PropertyService;
        this.PropertyDealService = PropertyDealService;
        this.LeadService = LeadService;
        this.item = data.item;

        this.$onInit = () => {
            this.form = {
                id: data.item.id,
                action: data.action,
                status: data.status
            }
            this.contractTypes = ['DEVELOPMENT', 'PRELIMINARY_SALE'];
            this.finalContractTypes = ['CONDITIONAL_SALE_BEFORE_OWNERSHIP_TRANSFER', 'OWNERSHIP_TRANSFER'];
        }

        this.onFinalContractChanged = () => {
            delete this.form.finalContract
            delete this.form.finalContractConditional
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            let form = angular.copy(this.form);
            if (form.contract?.agreementType === 'PRELIMINARY_SALE' && this.contractConditional === true) {
                form.contract.agreementType = 'CONDITIONAL_SALE';
            }
            return PropertyDeal.action(form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
    .controller('PropertyDealStatusTransferController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyDeal, Project, PropertyService, PropertyDealService, LeadService) {
        this.PropertyService = PropertyService;
        this.PropertyDealService = PropertyDealService;
        this.LeadService = LeadService;
        this.item = data.item;
        this.transferred = null;

        this.$onInit = () => {
            this.form = {
                id: data.item.id,
                action: data.action,
                status: data.status
            }
            this.contractTypes = ['DEVELOPMENT', 'PRELIMINARY_SALE', 'CONDITIONAL_SALE'];
            this.finalContractTypes = ['CONDITIONAL_SALE_BEFORE_OWNERSHIP_TRANSFER', 'OWNERSHIP_TRANSFER'];
        }

        this.fileUpload = (id, stage) => {
            PropertyDealService.upload(id, stage).then(result => {
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            return PropertyDeal.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                toastr.success("Zapisano");
                this.transferred = result;
            })
        };
    })
